'use strict';

import angular from 'angular';

import * as globalFilters from './global';

export default angular.module('globalFilters', [])
  .filter('ucFirst', globalFilters.ucFirst)
  .filter('priceDollar', globalFilters.priceDollar)
  .filter('priceCents', globalFilters.priceCents)
  .name;



// WEBPACK FOOTER //
// ./~/site_core/src/filters/index.js